<div
  class="wrapper"
  [class.collapsed-column]="!isColumnOpen()"
  (click)="handleWrapperClick()"
>
  <button
    (click)="handleButtonClick($event)"
  >
    {{ isColumnOpen() ? '-' : '+' }}
  </button>
  @if (!isColumnOpen()) {
    <div class="column-name">
      {{ columnName() }}
    </div>
  }
  @if (isColumnOpen()) {
    <div class="columns">
      @for (column of columns(); track $index) {
        <div
          class="column"
          [style.width.px]="widths()[$index]"
        >
          {{ column }}
        </div>
      }
    </div>
  }
</div>
